import Styles from './ImageEditor.module.scss'
import { Input } from 'almanac-ui/TextInputField/Input'
import { Button } from 'blaze-ui/Button/Button'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { Trash2 } from 'blaze-ui/icons'
import { Paperclip } from 'blaze-ui/icons/24'

interface PromptSectionProps {
  prompt: string
  imageUrls: string[]
  showImageAttach: boolean
  onPromptChange: (value: string) => void
  onRemoveAttachedImage: (index: number) => void
  onPickImage: () => void
  onConfirm: () => void
}

export const PromptSection = ({
  prompt,
  imageUrls,
  showImageAttach,
  onPromptChange,
  onRemoveAttachedImage,
  onPickImage,
  onConfirm,
}: PromptSectionProps) => (
  <div className={Styles.popoverPromptSection}>
    <Input
      name="prompt"
      isTextarea
      value={prompt}
      onChange={(e) => onPromptChange(e.target.value)}
      rows={1}
      size="md"
      placeholder="Describe a change..."
    />
    {showImageAttach && (
      <>
        {imageUrls.length > 0 && (
          <div className={Styles.attachedImages}>
            {imageUrls.map((url, i) => (
              <div key={i} className={Styles.attachedImage}>
                <img src={url} alt={`Attached reference ${i + 1}`} />
                <button type="button" className={Styles.removeAttachment} onClick={() => onRemoveAttachedImage(i)}>
                  <Trash2 />
                </button>
              </div>
            ))}
          </div>
        )}
      </>
    )}
    <div className={Styles.popoverActions}>
      {!showImageAttach && <div />}
      {showImageAttach && (
        <div>
          <IconButton variant="secondary" icon={Paperclip} aria-label="Attach image" onPress={onPickImage} />
        </div>
      )}
      <Button variant="primary" aria-label="Confirm" onPress={onConfirm}>
        Confirm
      </Button>
    </div>
  </div>
)
